// extracted by mini-css-extract-plugin
module.exports = {"title":"CardShortSkeleton__title__1mRuu","price":"CardShortSkeleton__price__20b6s"};